import React from "react";

const Footer = () => {
  return (
    <footer className="bg-gray-900 py-5 text-center text-white">
      <p>Copyright &copy; {new Date().getFullYear()} Built By Diba</p>
    </footer>
  );
};

export default Footer;
